import React, { Component } from 'react';
import styled from 'styled-components';

import { Subject } from '../../components/molecues';
import { DateSelector } from '../../components/molecues';

import { Button } from '../../../common/components/atoms';
import { SUBJECT_KBN } from '../../common/constants.js';

class SubjectPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDate: new Date(),
            sortMode: 0,
            sortTarget: "",
            subject: [],
            select: -1,
            checked: false,
        }
    }

    set(subject) {
        this.setState({ subject: subject });
    }
    get() {
        return this.state.subject;
    }
    push(subject) {
        let subjects = this.state.subject;
        subjects.push(subject);
        this.setState({ subject: subjects });
    }

    onChanageDate = (date) => {
        this.setState({ currentDate: date });
        this.props.setSubjectList(date);
    }

    onClickSubject(e, index) {
        if (this.state.sortMode !== 2) {
            this.setState({ select: index });
            this.props.onClickSubject(e, this.state.subject[index]);
        }
    }

    getSubjectList() {
        let subject = [];
        subject.push(
            <PanelWrap key={"panelblank"}>
                <div style={{ height: "5px" }}></div>
                <PileIcon onClick={e => this.onClickSortPile(e, 1)}
                    Mode={this.state.sortMode === 2}>
                    <i className="fas fa-angle-double-right" />
                </PileIcon>
            </PanelWrap>
        );
        for (let key in this.state.subject) {
            if (!this.state.subject[key].deleteFlg) {
                const props = {
                    subject: this.state.subject[key],
                    subjectKbn: this.state.checked ? SUBJECT_KBN.STOCK : SUBJECT_KBN.DELIVERY,
                    active: (this.state.sortTarget === key),
                    select: (this.state.select === key),
                    publish: this.state.subject[key].releaseFlg,
                    onClick: (e) => this.onClickSubject(e, key),
                    onClickEdit: (e) => this.props.onClickSubjectEdit(e, this.state.subject[key]),
                    onClickDelete: (e) => this.props.onClickSubjectDelete(e, this.state.subject[key]),
                    onClickHidden: (e) => this.props.onClickSubjectHidden(e, this.state.subject[key]),
                    admin: true,
                }
                subject.push(
                    <PanelWrap key={"panel" + key}
                        onClick={e => this.onClickSortTarget(e, key)}
                        onMouseDown={e => this.onMouseDownSortTarget(e, key)}
                        onMouseUp={e => this.onMouseUpSortTarget(e, key)}>
                        <Subject key={key} {...props}></Subject>
                        <PileIcon onClick={e => this.onClickSortPile(e, Number(key) + 2)}
                            Mode={this.state.sortMode === 2}>
                            <i className="fas fa-angle-double-right" />
                        </PileIcon>
                    </PanelWrap>
                );
            }
        }

        return subject;
    }

    onMouseDownSortTarget(e, id) {
        let count = 10;
        this.intervalId = setInterval(() => {
            count--;
            if (count === 0) {
                this.setState({
                    sortMode: 2,
                    sortTarget: id,
                });
            }
        }, 100);
    }

    onMouseUpSortTarget(e, id) {
        clearInterval(this.intervalId);
    }

    onClickSort = (e) => {
        if (Object.keys(this.state.subject).length === 0) return;

        let sortMode = this.state.sortMode;
        let sortTarget;
        if (sortMode === 0) {
            sortMode = 1;
            sortTarget = "";
        } else {
            sortMode = 0;
            sortTarget = "";
        }
        this.setState({
            sortMode: sortMode,
            sortTarget: sortTarget,
        });
    }
    onClickSortTarget(e, id) {
        if (this.state.sortMode === 1) {
            this.setState({
                sortMode: 2,
                sortTarget: id,
            });
        }
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        let order = 0;
        for (let key in list) {
            list[key].order = order;
            order++;
        }
        return list;
    }


    onClickSortPile(e, id) {
        let sortMode = this.state.sortMode;
        let sortTarget = this.state.sortTarget;
        if (sortMode === 2) {
            let temp = this.state.subject;
            for (let key in temp) {
                if ((Number(key)+1) >= id) {
                    temp[key].order = (Number(key)+1) + 1;
                }
            }
            temp[sortTarget].order = id;
            this.setState({
                subject: this.getSortedList(temp),
            });

            this.setState({
                sortMode: 0,
                sortTarget: "",
            });
            for (let key in temp) {
                this.props.dispatch({
                    type: "ChangeOrder_Saga",
                    id: temp[key].id,
                    order: temp[key].order,
                    mode: 0,
                    index: key,
                    onSuccess: this.onSuccess,
                    onFailure: this.onFailure,
                });
            }
        }
    }

    onChangeSubjectKbn(e) {
        let subjectKbn;
        if(e.target.checked){
            subjectKbn = SUBJECT_KBN.STOCK;
            this.setState({ checked: true });
        }else{
            subjectKbn = SUBJECT_KBN.DELIVERY;
            this.setState({ checked: false });
        }
        this.props.loadSubjectList(this.state.currentDate, subjectKbn);
    }

    render() {
        const propsCheck = {
            type: "checkbox",
            name: "checkSupjectKbn",
            checked: this.state.checked,
            onChange: e => this.onChangeSubjectKbn(e),
        };
        const propsDateSelector = {
            Display: (this.state.checked) ? false : true,
            onChange: this.onChanageDate,
        };
        const propsButton = {
            Color: "#0077FF",
            Width: "150px",
            onClick: this.props.onCilckAddSubject,
            text: "教材を追加",
        };

        return (
            <Items Height={this.props.itemHeight + "px"}>
                <Titles>
                    <Title>
                        音声教材一覧
                        <Icon onClick={this.onClickSort} Mode={this.state.sortMode}>
                            <i className="fas fa-list" />
                        </Icon>
                    </Title>
                    <SubjectKbn>
                        <Check {...propsCheck}/>
                        ストック教材
                    </SubjectKbn>
                </Titles>

                <DateSelector {...propsDateSelector} />
                <Scroll Height={this.props.scrollHeight + "px"}>
                    <Panels>
                        {this.getSubjectList()}
                    </Panels>
                </Scroll>
                <Button{...propsButton} />
            </Items>
        );
    }
}

export { SubjectPanel };

const Items = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    width: 320px;
    height: ${props => (props.Height)};

`;

const Titles = styled.div`
    display: flex;
    align-items: center;
`;

const Title = styled.div`
    display: flex;
    color: #888;
    font-weight: bold;
`;

const Check = styled.input`
    position: relative;
    top: 2px;
    margin: 0px 5px 0px 5px;
`;

const SubjectKbn = styled.div`
    color: #888;
    font-weight: bold;
`;

const Icon = styled.div`
    color: ${props => props.Mode ? "#f900a1" : "#888"};
    margin: 0px 10px 0px 5px;
`;
const Scroll = styled.div`
    width: 100%;
    height: ${props => (props.Height)};
    overflow: hidden auto;
    margin-bottom: 10px;

    ::-webkit-scrollbar{
    　　width: 10px;
    }
    ::-webkit-scrollbar-track{
    　　background: #fff;
    }
    ::-webkit-scrollbar-thumb{
    　　background: #ccc;
    　　border-radius: 10px;
    　　box-shadow: inset 0 0 0 2px #fff;
    }
`;

const Panels = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    width: calc(100% - 20px);
    position: relative;
`;
const PanelWrap = styled.div`
    margin: 0;
    padding: 0;
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;
const PileIcon = styled.div`
    position: absolute;
    bottom: -10px;
    left: ${props => props.Mode ? "0px" : "-5px"};
    font-size: 14px;
    opacity: ${props => props.Mode ? "1" : "0"};
    color: #f900a1;
    transition-duration: 0.2s;
    cursor: pointer;
    z-index: 1;
`;
